var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHermesLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 16,
    viewBox: "0 0 100 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0246 5.05418L25.0246 0.915039H22.7246L21.7246 5.05418",
    fill: "url(#paint0_linear_3295_40983)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4055 10.5361L23.4055 6.39697H21.1055L20.1055 10.5361",
    fill: "url(#paint1_linear_3295_40983)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4055 15.5454L22.4055 11.4062H20.1055L19.1055 15.5454",
    fill: "url(#paint2_linear_3295_40983)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7548 5.05418L21.7547 0.915039H0.966797L4.59643 5.05418",
    fill: "url(#paint3_linear_3295_40983)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5868 5.05418L0.966797 0.915039V2.22794L3.9668 5.08424",
    fill: "url(#paint4_linear_3295_40983)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3649 10.406L20.4648 6.25684H6.57617L10.2758 10.406",
    fill: "url(#paint5_linear_3295_40983)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2762 10.4058L6.57617 6.20654V7.44929L9.76617 10.4559",
    fill: "url(#paint6_linear_3295_40983)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.037 15.7659L19.107 11.6167H12.207L15.897 15.7659",
    fill: "url(#paint7_linear_3295_40983)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9656 15.7659L12.2656 11.6167V12.7893L15.4456 15.7959",
    fill: "url(#paint8_linear_3295_40983)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9273 3.88093L99.5673 5.26377C99.4173 5.91511 99.0574 6.14559 98.3175 6.14559H96.0977C95.0978 6.14559 94.7578 6.20571 94.5478 6.43619C94.4399 6.55473 94.3582 6.69471 94.3079 6.84703C94.2489 6.99302 94.2282 7.15172 94.2479 7.30798C94.2479 7.68876 94.3978 7.81903 94.9878 7.95932L97.1976 8.61066C98.7474 9.05157 99.1974 9.49248 99.1974 10.6148C99.187 11.9833 98.8069 13.3234 98.0975 14.4928C97.7743 14.8976 97.3548 15.2146 96.8776 15.4147C96.3978 15.6172 95.877 15.703 95.3577 15.6652H89.8683C89.7861 15.6848 89.7005 15.6848 89.6183 15.6652C89.5383 15.636 89.4687 15.5837 89.4183 15.5149C89.3683 15.4513 89.3371 15.3749 89.3284 15.2944C89.308 15.2122 89.308 15.1262 89.3284 15.0439L89.9883 12.3484H90.6482C90.7982 12.9295 91.2382 13.14 92.1281 13.14H94.2779C95.0878 13.14 95.4677 12.9997 95.6777 12.7893C95.9362 12.5267 96.0862 12.1759 96.0977 11.8072C96.0977 11.3062 95.9577 11.1559 94.8478 10.9254L92.608 10.4044C91.4181 10.1138 90.9082 9.45239 90.9082 8.50044C90.9962 7.39492 91.3385 6.32484 91.9081 5.374C92.498 4.37194 93.4579 3.90097 95.0878 3.90097H99.9673L99.9273 3.88093ZM50.6322 6.80695C50.5858 7.83951 50.3625 8.85638 49.9723 9.81314C49.7623 10.244 49.4624 10.3943 48.3425 10.3943H43.163L42.953 11.3162C42.9033 11.5567 42.8831 11.8024 42.893 12.0477C42.874 12.248 42.9122 12.4495 43.003 12.6289C43.0947 12.809 43.2327 12.9613 43.403 13.0698C43.9804 13.3382 44.6203 13.4422 45.2528 13.3705C47.3126 13.3705 47.7525 13.0698 48.4325 12.198H49.1024L48.6624 13.8013C48.3625 14.9738 48.2925 15.1842 47.8425 15.4147C46.7234 15.792 45.5405 15.9419 44.3629 15.8556C43.2576 15.9365 42.1475 15.7863 41.1032 15.4147C40.6322 15.1341 40.2506 14.7251 40.0027 14.2354C39.7549 13.7457 39.651 13.1955 39.7033 12.649C39.809 10.1859 40.5683 7.79563 41.9031 5.72472C43.003 4.3519 44.4129 3.83083 46.8526 3.83083C49.5123 3.74064 50.6822 4.6926 50.6322 6.80695ZM48.0425 7.16769C48.0425 6.28588 47.5325 5.93516 46.3427 5.93516C44.7928 5.93516 44.2029 6.51635 43.6929 8.40023H47.8125C47.9438 8.00152 48.0211 7.58699 48.0425 7.16769ZM88.9084 6.80695C88.87 7.83954 88.65 8.85722 88.2585 9.81314C88.0385 10.244 87.6585 10.3142 86.5586 10.3142H81.3691L81.1592 11.2661C81.1061 11.5062 81.0826 11.7518 81.0892 11.9976C81.0788 12.1985 81.1201 12.3986 81.2092 12.5788C81.3008 12.7589 81.4389 12.9112 81.6091 13.0197C82.1895 13.278 82.8276 13.3782 83.4589 13.3103C85.5187 13.3103 85.9587 13.0197 86.6386 12.1479H87.2985L86.8786 13.7412C86.5786 14.9136 86.5186 15.1241 86.0687 15.3445C84.9516 15.7309 83.7674 15.8844 82.589 15.7954C81.4861 15.8777 80.3784 15.724 79.3393 15.3445C78.8692 15.0656 78.4879 14.6584 78.2401 14.1704C77.9922 13.6825 77.8879 13.1339 77.9395 12.5888C78.0438 10.124 78.807 7.7326 80.1493 5.6646C81.2492 4.29177 82.649 3.76068 85.1488 3.76068C87.8785 3.76068 89.0584 4.71264 89.0084 6.81697L88.9084 6.80695ZM86.3287 7.16769C86.3287 6.28588 85.8187 5.93516 84.6288 5.93516C83.069 5.93516 82.479 6.51635 81.9691 8.40023H86.0987C86.23 8.00155 86.3074 7.587 86.3287 7.16769ZM40.1033 1.55614C40.1237 1.48068 40.1237 1.40114 40.1033 1.32567C40.0888 1.24497 40.0545 1.16918 40.0033 1.10522C39.9536 1.04235 39.888 0.993919 39.8133 0.964927C39.7441 0.923584 39.6634 0.905993 39.5833 0.914824H36.2837L36.2137 1.38579C36.8136 1.5361 36.5836 2.18744 36.5136 2.47804C36.3637 3.12938 35.5138 6.40613 35.5138 6.40613H31.0142L32.2641 1.59623C32.3341 1.2455 32.2041 0.954907 31.7541 0.954907H28.3845L28.3245 1.38579C28.9144 1.5361 28.6844 2.18744 28.6144 2.47804C28.1745 4.48217 25.2848 15.2143 25.2848 15.2143C25.2644 15.2965 25.2644 15.3825 25.2848 15.4648C25.2935 15.5453 25.3247 15.6217 25.3748 15.6852C25.427 15.7521 25.496 15.804 25.5747 15.8355C25.6569 15.8551 25.7425 15.8551 25.8247 15.8355H29.1044L29.1744 15.4046C28.5844 15.2543 28.8044 14.603 28.8744 14.3124C28.9444 14.0218 30.2743 8.77099 30.2743 8.77099H34.8038L33.104 15.1641C33.0828 15.2463 33.0828 15.3325 33.104 15.4147C33.1125 15.4983 33.1436 15.578 33.194 15.6451C33.2462 15.7121 33.3152 15.7639 33.394 15.7954C33.4761 15.815 33.5618 15.815 33.6439 15.7954H36.9736L37.0436 15.3545C36.4437 15.2042 36.6736 14.5629 36.7436 14.2623C36.8136 13.9617 40.1033 1.55614 40.1033 1.55614ZM75.0098 3.8208H73.36C73.0143 3.78903 72.6669 3.85866 72.3601 4.02122C72.0394 4.18574 71.78 4.44922 71.6201 4.77276L71.0302 5.7147C71.1002 4.77276 70.5802 3.8208 68.9704 3.8208H67.4405C67.0816 3.77676 66.7175 3.83522 66.3902 3.98945C66.063 4.14369 65.7858 4.38743 65.5907 4.6926L64.9408 5.57441L65.2308 4.57235C65.2511 4.49009 65.2511 4.4041 65.2308 4.32184C65.223 4.23921 65.1878 4.16158 65.1308 4.10138C65.0823 4.03483 65.0166 3.98284 64.9408 3.95107C64.8586 3.93148 64.773 3.93148 64.6908 3.95107H61.7811L61.6311 4.38196C61.7501 4.40961 61.8581 4.47245 61.9411 4.56233C62.0225 4.65342 62.0686 4.77075 62.0711 4.89301C62.0815 5.04255 62.0611 5.19263 62.0111 5.33392L59.4213 15.2243C59.401 15.3065 59.401 15.3925 59.4213 15.4748C59.4301 15.5553 59.4613 15.6317 59.5113 15.6952C59.5636 15.7622 59.6326 15.814 59.7113 15.8456C59.7935 15.8651 59.8791 15.8651 59.9613 15.8456H62.961L63.031 15.4046C62.9264 15.3872 62.831 15.3341 62.761 15.2543C62.6989 15.1738 62.6639 15.0755 62.661 14.9738C62.6697 14.8017 62.6931 14.6307 62.731 14.4627C62.731 14.4627 64.4308 8.27998 64.4308 8.20984C64.7908 6.59652 65.2408 6.45623 66.1307 6.30592H66.7206C67.5305 6.30592 67.8305 6.80695 67.7205 7.39817C67.7205 7.53846 65.7207 15.2543 65.7207 15.2543C65.7008 15.3333 65.7008 15.4159 65.7207 15.4948C65.7374 15.5718 65.7716 15.6438 65.8207 15.7053C65.8728 15.7682 65.9375 15.8194 66.0107 15.8556C66.0866 15.8707 66.1647 15.8707 66.2407 15.8556H69.2404L69.1004 15.4147C68.9979 15.3993 68.905 15.3456 68.8404 15.2644C68.7741 15.1862 68.7385 15.0864 68.7404 14.9838C68.7406 14.8117 68.7607 14.6402 68.8004 14.4727L70.5002 8.21986C70.9502 6.61656 71.3102 6.46625 72.2001 6.31594H72.8C73.6899 6.31594 73.8999 6.81697 73.7999 7.40819C73.7999 7.46831 71.8001 15.2744 71.8001 15.2744C71.7798 15.3532 71.7798 15.436 71.8001 15.5149C71.8104 15.598 71.8413 15.6773 71.8901 15.7453C71.9479 15.8063 72.0155 15.8571 72.0901 15.8957C72.1723 15.9152 72.2579 15.9152 72.34 15.8957H75.3397L75.4097 15.4547C75.3052 15.4373 75.2098 15.3842 75.1398 15.3044C75.0775 15.2201 75.0426 15.1187 75.0398 15.0138C75.0477 14.845 75.0711 14.6773 75.1098 14.5128C75.1098 14.5128 77.1096 6.64662 77.1696 6.28588C77.3895 5.38402 77.3895 3.7707 75.0898 3.7707L75.0098 3.8208ZM58.4714 3.88093C57.7215 3.88093 57.6615 3.88093 57.2816 4.39198L56.3917 5.55437L56.6916 4.55231C56.7119 4.47344 56.7119 4.39069 56.6916 4.31182C56.6832 4.2323 56.6479 4.15805 56.5916 4.10138C56.5453 4.03282 56.479 3.98031 56.4017 3.95107C56.323 3.93026 56.2403 3.93026 56.1617 3.95107H53.162L53.092 4.39198C53.1966 4.4094 53.2919 4.4625 53.362 4.54229C53.4282 4.62443 53.4636 4.72727 53.4619 4.83289C53.4541 5.0017 53.4306 5.16942 53.392 5.33392L50.8022 15.2343C50.7873 15.3138 50.7873 15.3953 50.8022 15.4748C50.8208 15.5541 50.8548 15.629 50.9022 15.6952C50.9563 15.756 51.0206 15.8069 51.0922 15.8456C51.1715 15.86 51.2528 15.86 51.3322 15.8456H54.3319L54.3919 15.4046C54.2873 15.3872 54.1919 15.3341 54.1219 15.2543C54.0584 15.1712 54.0265 15.0682 54.0319 14.9637C54.0305 14.7777 54.054 14.5923 54.1019 14.4126L55.8017 8.06955C56.1717 6.61656 56.5516 6.31594 57.8615 6.31594H59.0514C59.9413 6.31594 60.2413 6.10551 60.3913 5.44415L60.8312 3.91099L58.4714 3.88093Z",
    fill: "#3D3C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3295_40983",
    x1: 23.7546,
    y1: 5.13435,
    x2: 23.0215,
    y2: 0.875491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65656A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A9A9AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D9D9DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECEBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3295_40983",
    x1: 22.1355,
    y1: 10.6163,
    x2: 21.4023,
    y2: 6.35742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65656A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A9A9AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D9D9DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECEBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3295_40983",
    x1: 21.1355,
    y1: 15.6256,
    x2: 20.4023,
    y2: 11.3667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65656A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A9A9AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D9D9DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECEBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3295_40983",
    x1: 6.15628,
    y1: 7.00849,
    x2: 18.2586,
    y2: -3.29671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CBE4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#97CDE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#6BBADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#43AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#289CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#1293C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#068EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3295_40983",
    x1: -0.163203,
    y1: 0.373845,
    x2: 4.72814,
    y2: 5.51442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#DDEDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C5E1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9FD0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#68B9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#209ACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3295_40983",
    x1: 6.54617,
    y1: 8.2813,
    x2: 20.4748,
    y2: 8.2813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#C0DFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#87C2DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#57ABCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3099C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#198EBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0A86B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3295_40983",
    x1: 5.84617,
    y1: 6.12637,
    x2: 10.4558,
    y2: 10.4959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C8E2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#77BBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3295_40983",
    x1: 12.057,
    y1: 12.4185,
    x2: 18.5385,
    y2: 13.9355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#C6E0EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#81BDD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4BA3C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#238FBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0E82B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0A7EB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3295_40983",
    x1: 11.7056,
    y1: 11.6768,
    x2: 16.4656,
    y2: 16.1763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#90C5DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#449EC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1487B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A7EB0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHermesLogo);
export default __webpack_public_path__ + "static/media/hermes_logo.4db9b01cbf7bc04b3b8f0dcc35a03055.svg";
export { ForwardRef as ReactComponent };